export default function UnderConstruction() {

	return (
			<h1>This site is under construction!</h1>
	);

}
